import { Path } from '~/routes/constants';

import { MaudPermissions } from '../constants/permissions.constants';

const isAvailabilityAuthorized = (
  permissions: Record<MaudPermissions, boolean>,
): boolean => {
  return (
    permissions[MaudPermissions.MAUD_AVAILABILITY] ||
    permissions[MaudPermissions.MAUD_SCHEDULE_PROXY]
  );
};

/** For routes without permission-level authorization -- for now only "calendar" routes use this feature */
const allowAll = (_permissions: Record<MaudPermissions, boolean>): boolean =>
  true;

const RouteAuthorizerMap: Partial<
  Record<Path, (permissions: Record<MaudPermissions, boolean>) => boolean>
> = {
  [Path.ADMIN]: allowAll,
  [Path.ADMIN_USERS]: allowAll,
  [Path.CALENDAR]: allowAll,
  [Path.CALENDAR_AVAILABILITY]: isAvailabilityAuthorized,
  [Path.CALENDAR_GROUP]: allowAll,
  [Path.CALENDAR_GROUP_CLASS]: allowAll,
  [Path.CALENDAR_INTEGRATION]: allowAll,
  [Path.CALENDAR_SCHEDULE]: allowAll,
  [Path.HOME]: allowAll,
  [Path.LOGIN]: allowAll,
  [Path.MAUD]: allowAll,
  [Path.MAUD_ANALYTICS]: allowAll,
  [Path.MAUD_INQUIRIES]: allowAll,
  [Path.MAUD_PATIENTS]: allowAll,
  [Path.MAUD_SURVEYS]: allowAll,
  [Path.MAUD_TASKS]: allowAll,
  [Path.PORTAL]: allowAll,
  [Path.SETTINGS]: allowAll,
};

const isAuthorizedRoute = (
  route: string,
  permissions: Record<MaudPermissions, boolean>,
): boolean => {
  return RouteAuthorizerMap[route]?.(permissions) ?? false;
};

export { isAuthorizedRoute, isAvailabilityAuthorized };
